import { render, staticRenderFns } from "./WorkBookQuestionsOpenTopEntry.vue?vue&type=template&id=6677bf18&scoped=true&"
import script from "./WorkBookQuestionsOpenTopEntry.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsOpenTopEntry.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsOpenTopEntry.vue?vue&type=style&index=0&id=6677bf18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677bf18",
  null
  
)

export default component.exports